// CascadingSelect — фильтрует зависимые SLT-select'ы по значению родительского.
//
// Контракт по разметке (см. mixin sel в Form-elements.pug):
//   <select name="slt_regions" data-parent-field="slt_countries">
//     <option value="42" data-parent-key="51">Анталия</option>
//     ...
//   </select>
//
// Поведение:
//   * При смене родителя — в зависимом select'е прячутся (через disabled+display:none)
//     опции, у которых data-parent-key !== выбранному значению родителя.
//   * Если выбранная в зависимом опция стала недоступной — выбор сбрасывается,
//     а зависимый сам триггерит change (каскад идёт глубже — например, страна → регион → локация).
//   * Если родитель пуст — показываются все опции (мягкий режим, выбранный пользователем).
//
// Применяется ко всем select[data-parent-field] в форме при инициализации
// и при каждом редактировании формы (vform.applyEvents хук, см. ниже).

export class CascadingSelect {
	constructor(root) {
		this.root = root || document;
		this.bind();
		this.applyAll();
	}

	bind() {
		const handler = (e) => {
			const sel = e.target;
			if (sel.tagName !== 'SELECT') return;
			// перебрать все select'ы, у которых parent === этот select
			this.applyDependents(sel.name);
		};
		this.root.addEventListener('change', handler, true);
	}

	applyAll() {
		const dependents = this.root.querySelectorAll('select[data-parent-field]');
		dependents.forEach((sel) => this.applyOne(sel));
	}

	applyDependents(parentName) {
		if (!parentName) return;
		const sels = this.root.querySelectorAll('select[data-parent-field="' + parentName + '"]');
		sels.forEach((sel) => this.applyOne(sel));
	}

	applyOne(sel) {
		const parentName = sel.getAttribute('data-parent-field');
		const parent = this.root.querySelector('select[name="' + parentName + '"]');
		const parentValue = parent ? parent.value : '';

		let currentSelectionStillValid = true;

		Array.from(sel.options).forEach((opt) => {
			// опция без data-parent-key (например пустой "—") — всегда видна
			const key = opt.getAttribute('data-parent-key');
			if (key === null || key === '') {
				opt.hidden = false;
				opt.disabled = false;
				return;
			}

			// родитель пуст — показываем все варианты (soft-режим)
			if (!parentValue) {
				opt.hidden = false;
				opt.disabled = false;
				return;
			}

			// сравниваем как строки, чтобы "0" не путался с пустотой
			const match = String(key) === String(parentValue);
			opt.hidden = !match;
			opt.disabled = !match;
			if (!match && opt.selected) {
				currentSelectionStillValid = false;
			}
		});

		if (!currentSelectionStillValid) {
			// сбрасываем на пустую/первую видимую опцию и пускаем change для каскада
			const firstVisible = Array.from(sel.options).find((o) => !o.hidden);
			sel.value = firstVisible ? firstVisible.value : '';
			sel.dispatchEvent(new Event('change', { bubbles: true }));
		}
	}
}
